angular.module 'zc.users'

.config ($stateProvider) ->
  $stateProvider
  .state 'users',
    abstract: true
    url: '/users'
    views:
      'header@':
        templateUrl: '/templates/users/views/devise_header.html'

  .state 'users.signIn',
    url: '/sign_in'
    views:
      'content@':
        templateUrl: '/templates/users/views/sign_in.html'
        controller: 'UsersSignInCtrl'

  .state 'users.password',
    abstract: true
    url: '/password'

  .state 'users.password.forgot',
    url: '/new'
    views:
      'content@':
        templateUrl: '/templates/users/views/password/forgot.html'
        controller: 'ForgotUserPasswordCtrl'

  .state 'users.password.reset',
    url: '/edit?reset_password_token'
    views:
      'content@':
        templateUrl: '/templates/users/views/password/reset.html'
        controller: 'ResetUserPasswordCtrl'

  .state 'users.invitation',
    abstract: true
    url: '/invitation'

  .state 'users.invitation.accept',
    url: '/accept?invitation_token'
    views:
      'content@':
        templateUrl: '/templates/users/views/invitation/accept.html'
        controller: 'AcceptUserInvitationCtrl'
    resolve:
      user: ($stateParams, Devise) ->
        return Devise
          .validateInvitationToken($stateParams.invitation_token)
          .then (user) ->
            # set the current user here so that the languageSelectHeader uses
            # the user language
            Devise.currentUser = user
            return user

  .state 'admin',
    abstract: true
    url: '/admin'
    views:
      'header@':
        templateUrl: '/templates/core/views/admin_header.html'
        controller: 'AdminHeaderCtrl'
      'mainnav@':
        template: ''
    resolve:
      currentUser: (Devise) ->
        Devise.getCurrentUser()

  .state 'admin.users',
    url: '/users'
    abstract: true

  .state 'admin.users.inquiry',
    url: '/inquiry'
    views:
      'content@':
        templateUrl: '/templates/users/inquiry.html'
        controller: 'InquiryCtrl'
        resolve:
          reasons: (Inquiry) ->
            Inquiry.getReasons()


  .state 'admin.users.edit',
    url: '/edit'
    views:
      'content@':
        templateUrl: '/templates/users/views/edit.html'
        controller: 'EditUserCtrl'
        resolve:
          user: (Devise) ->
            Devise.getCurrentUser()

  .state 'admin.users.password',
    url: '/password'
    abstract: true
  .state 'admin.users.password.edit',
    url: '/edit'
    views:
      'content@':
        templateUrl: '/templates/users/views/password/edit.html'
        controller: 'EditUserPasswordCtrl'



// WEBPACK FOOTER //
// ./src/zenclerk_modules/users/routes.js.coffee